import * as pkg from '../../package.json';

export class Version {
  public static readonly version: string = pkg.version;
}
